import { render, staticRenderFns } from "./perinfo.vue?vue&type=template&id=19969802&scoped=true"
import script from "./perinfo.vue?vue&type=script&lang=js"
export * from "./perinfo.vue?vue&type=script&lang=js"
import style0 from "@/styles/roatestyle.css?vue&type=style&index=0&id=19969802&prod&scoped=true&lang=css&external"
import style1 from "./perinfo.vue?vue&type=style&index=1&id=19969802&prod&scoped=true&lang=scss"
import style2 from "./perinfo.vue?vue&type=style&index=2&id=19969802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19969802",
  null
  
)

export default component.exports